export default "__VITE_ASSET__CcVOGuS$__"